​import { Component, OnInit, ViewChild, EventEmitter, Output, ChangeDetectorRef, inject, TemplateRef, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from 'src/services/admin.service';
import { Router } from '@angular/router';
import { participantDetails, participantDetailsExport, participantAnswers, ParticipantDynamicValuesModel, StudyNote, groupMemberDetails } from 'src/app/model/participant.model';
import { DatePipe } from '@angular/common';
import { ExcelExportService } from 'src/app/service/excel-export.service';
import { Settings } from "ngx-datetime-range-picker";
import { Function, ApplicantStatus, StatusReason } from 'src/Utilities/enum';
import { ConversionHelper, DateHelper, StringHelper } from 'src/Utilities/utility';
import { ParticipantService } from 'src/services/participant.service';
import { ApplicantStatusModel, StatusReasonModel, RaceModel } from 'src/models/participant.model';
import { AuthStore } from 'src/app/store/authorization/auth.store';
import { AuditParticipants, AuditParticipantsBySP } from 'src/app/model/audit-participants';
import { DynamicColumnConfig, DynamicTableConfig, DynamicTableFilter } from 'src/app/shared/dynamic-table/dynamic-table.model';
import { Table } from 'primeng/table';
import { AppService } from 'src/app/app.service';
import { SHARED_IMPORTS } from 'src/app/shared/shared.module';
import { DynamicTableComponent } from 'src/app/shared/dynamic-table/dynamic-table.component';
import { BehaviorSubject, map } from 'rxjs';
import { SharedDatepickerComponent } from 'src/app/shared/shared-datepicker/shared-datepicker.component';

export interface CommunicationNote {
  ParticipantId: number;
  Note: string;
  CreatedBy: string;
  CreatedOn: Date;
}

@Component({
  selector: 'app-admin-participant-answers',
  templateUrl: './admin-participant-answers.component.html',
  styleUrls: ['./admin-participant-answers.component.css'],
  standalone: true,
  imports: [...SHARED_IMPORTS,DynamicTableComponent,SharedDatepickerComponent]

})
export class AdminParticipantAnswersComponent implements OnInit {

  stringHelper = StringHelper;

  @Output() messageToParent = new EventEmitter<string>();
  pid: number;
  sid: number;
  participantAnswers: participantAnswers[] = [];
  participantDetailsExport: participantDetails;
  exportDetails: participantDetailsExport[] = [];
  participantDetails: participantDetails = {} as participantDetails;
  lastUpdated: any;
  applicantStatus: string[] = [];
  statusReasons: string[] = [];
  public itemListResponse: ParticipantDynamicValuesModel[] = [];

  communicationNotes: CommunicationNote[] = [];
  communicationNotes$ = new BehaviorSubject<CommunicationNote[]>([]);
  communicationNote: CommunicationNote = { ParticipantId: 0, Note: '', CreatedBy: '', CreatedOn: new Date() };
  currentDate: string = '';
  currentUserId: string;

  public min = new Date(1900, 0, 1, 0, 0);
  rawDate = new Date();
  rawHour = this.rawDate.getHours();
  rawMin = this.rawDate.getMinutes();
  dateonly = this.rawDate.getDate();
  monthonly = this.rawDate.getMonth() + 1;
  yearonly = this.rawDate.getFullYear();
  setMaxDate = (this.monthonly + "-" + this.dateonly + "-" + this.yearonly).toString();

  fullHour = (this.rawHour + ":" + this.rawMin).toString();
  public tempLastUpdate: string = "01-01-2017";
  public selectedOption = "daily";
  public selectedOptions: any;
  public dateTimeRangePickerSettings: Settings = this.getDateTimeRangeSettings();
  dateModel: Date = new Date();

  dobModel: Date;
  icfVersionDateModel: Date;
  screeningDateModel: Date;
  enrollmentDateModel: Date;

  applicantStatusList: ApplicantStatusModel[] = [];
  statusReasonList: StatusReasonModel[] = [];
  filteredStatusReasonList: StatusReasonModel[] = [];

  newTextField: string = '';
  showNewTextField: boolean = false;
  showStatusReason: boolean = false;
  minDate: Date = new Date(1900, 0, 1);
  maxDate: Date = new Date();
  dobChecked: boolean = true;
  screeningDateAutoSet = false;
  completedStudyDate: Date | null = null;
  cancelledDate: Date | null = null;
  scheduledDate: Date | null = null;
  screenFailedDate: Date | null = null;
  earlyTerminationDate: Date | null = null;
  lostToFollowUpDate: Date | null = null;

  showCompletedStudyDate = false;
  showCancelledDate = false;
  showScheduledDate = false;
  showScreenFailedDate = false;
  showEarlyTerminationDate = false;
  showLostToFollowUpDate = false;
  isSection1Collapsed = false;
  isSection2Collapsed = false;
  isSection3Collapsed = false;
  isSection4Collapsed = false;

  statusReasonStatuses: number[] = [ApplicantStatus.ScreenFailed, ApplicantStatus.EarlyTermination];
  newTextFieldStatuses: number[] = [ApplicantStatus.Cancelled, ApplicantStatus.Other];
  newTextFieldReasonIds: number[] = [StatusReason.Other, StatusReason.EarlyTerminatedOther];


  statusOptionMap: { [key: number]: number[] } = {
    [ApplicantStatus.Incomplete]: [ApplicantStatus.Contacted, ApplicantStatus.Prescreened, ApplicantStatus.Scheduled, ApplicantStatus.Disqualified],
    [ApplicantStatus.PreQualified]: [ApplicantStatus.Contacted, ApplicantStatus.Prescreened, ApplicantStatus.Disqualified, ApplicantStatus.Processed, ApplicantStatus.PreQualified, ApplicantStatus.Scheduled],
    [ApplicantStatus.Disqualified]: [ApplicantStatus.Scheduled, ApplicantStatus.Processed, ApplicantStatus.Disqualified],
    [ApplicantStatus.Contacted]: [ApplicantStatus.Scheduled, ApplicantStatus.Processed, ApplicantStatus.Disqualified, ApplicantStatus.Contacted],
    [ApplicantStatus.Prescreened]: [ApplicantStatus.Scheduled, ApplicantStatus.Processed, ApplicantStatus.Disqualified, ApplicantStatus.Contacted, ApplicantStatus.Prescreened],
    [ApplicantStatus.Scheduled]: [ApplicantStatus.Screened, ApplicantStatus.Cancelled, ApplicantStatus.Scheduled],
    [ApplicantStatus.Screened]: [ApplicantStatus.Enrolled, ApplicantStatus.ScreenFailed, ApplicantStatus.Screened],
    [ApplicantStatus.Enrolled]: [ApplicantStatus.CompletedStudy, ApplicantStatus.EarlyTermination, ApplicantStatus.LosttoFollowUp, ApplicantStatus.Enrolled]
  };

  showScreeningFields: boolean = false;
  showEnrollmentFields: boolean = false;
  isAuditLoading: boolean = false;
  isAuditLoadingBySp: boolean = false;
  updateGroupMembership: boolean = false;
  filteredStatusOptions = [];
  screeningEditableStatuses: number[] = [
    ApplicantStatus.Screened
  ];
  enrollmentEditableStatuses: number[] = [
    ApplicantStatus.Enrolled
  ];

  private readonly authStore = inject(AuthStore);
  raceOptions: RaceModel[] = [];
  emailPattern = "[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}";
  middleInitialInvalid: boolean = false;
  validationErrorMessage: boolean = false;
  showValidationMessage: boolean = false;

  get gridEnabled(): boolean {
    return this.authStore.isVisible(Function.EditApplicant);
  }

  get exportVisible(): boolean {
    return this.authStore.isVisible(Function.ExportApplicant);
  }

  get hasAnyError(): boolean {
    return this.middleInitialInvalid === true ||
      !this.dobChecked;
  }

  userId: string;
  icfDateError: string;
  enrollmentDateError: string;
  ApplicantStatusDisabled = false;
  isCollapsed = true;
  auditParticipants: AuditParticipants[] = [];
  dynamicColumns: DynamicColumnConfig[] = [];
  tableConfig: DynamicTableConfig;
  cellTemplates: { [field: string]: TemplateRef<any> } = {};
  cols: any[];
  auditParticipantsExport: AuditParticipants[] = [];
  isSearchFilterApplied = false;
  @ViewChild('dt') tableData: Table;
  @ViewChild('scrollTop', { static: true }) scrollTop: ElementRef;
  auditParticipantsBySp: AuditParticipantsBySP[] = [];
  dynamicColumnsbySp: DynamicColumnConfig[] = [];
  isCollapsedbySp = true;
  tableConfigBySP: DynamicTableConfig;
  studyNoteDetails: StudyNote[] = [];
  studyNoteDetails$ = new BehaviorSubject<StudyNote[]>([]);
  studyNote: StudyNote = { ParticipantId: 0, StudyId: 0, Note: '', CreatedBy: '', CreatedOn: new Date() };

  // Group Member Selection Dialog
  showGroupMemberDialog: boolean = false;
  groupMembersList: groupMemberDetails[] = [];
  selectedGroupMember: groupMemberDetails | null = null;
  heightForDisplay = null;

  constructor(
    private route: ActivatedRoute,
    private admin: AdminService,
    private router: Router,
    private exportExcel: ExcelExportService,
    private participantService: ParticipantService,
    private cdr: ChangeDetectorRef,
    private appService: AppService
  ) {
    this.pid = Number(this.route.snapshot.paramMap.get("pid"));
    this.sid = Number(this.route.snapshot.paramMap.get("sid"));

    let datePipe = new DatePipe('en-US');
    this.currentDate = datePipe.transform(new Date(), 'dd/MMM/yyyy') || '';

  }

  ngOnInit() {
    this.appService.currentUserId$.subscribe(id => {
      this.currentUserId = id;
    });

    this.participantService.GetApplicantStatus().subscribe((data) => {
      this.applicantStatusList = Array.isArray(data) ? data : [];
      this.loadParticipantData();
    });

    this.participantService.getStatusReason().subscribe((data) => {
      this.statusReasonList = Array.isArray(data) ? data : [];
      if (this.participantDetails && this.participantDetails.ApplicantStatusId) {
        this.filterStatusReasonsByStatus();
        this.updateUIForStatus((this.participantDetails.ApplicantStatusId));
        this.cdr.detectChanges();
      }
    });

    this.participantService.GetRaceOptions().subscribe((data) => {
     Promise.resolve().then(() => {
          this.raceOptions = Array.isArray(data) ? data : [];
           this.cdr.markForCheck();
      });
    });

    this.updateScreeningFieldsVisibility();
    this.GetApplicantCommunicationNote();

    this.tableConfigBySP = {
      rows: 50,
      selectable: false,
      selectionMode: 'multiple',
      globalSearch: false,
      exportable: true,
      deletable: false,
      lazy: false,
      dataKey: 'participantAuditIdbySP',
      preferenceKey: 'ApplicantAuditBySp',
      supportFilterHierarchy: true,
      title: '',
      columnFilteringEnabled: false,
      addable: false,
      showPagination: true
    };
    // Initialize dynamic columns configuration
    this.dynamicColumnsbySp = [
      { field: 'Action', header: 'Action performed', width: '70px', sortable: false },
      { field: 'ModifiedOn', header: 'Modified On', width: '150px', sortable: false, filterable: false, filterType: 'multiselect', filterField: 'ModifiedOn', filterOptions: [] },
      { field: 'ModifiedBy', header: 'Modified By', width: '120px', sortable: false, filterable: false, filterType: 'multiselect', filterField: 'ModifiedBy', filterOptions: [] },
      { field: 'ColName', header: 'Field Name', width: '110px', sortable: false, filterable: false, filterType: 'multiselect', filterField: 'ColName', filterOptions: [] },
      { field: 'PrevValue', header: 'Previous Value', width: '110px', sortable: false, filterable: false, filterType: 'multiselect', filterField: 'PrevValue', filterOptions: [] },
      { field: 'NewValue', header: 'Updated Value', width: '120px', sortable: false, filterable: false, filterType: 'multiselect', filterField: 'NewValue', filterOptions: [] },
    ];
    this.GetAuditParticipantsBySP();
    this.getStudyNote();
  }

  loadParticipantData() {
    this.admin.getParticipantDetails(this.pid, this.sid).subscribe(response => {
      Promise.resolve().then(() => {
        this.participantDetails = {
          ParticipantId: response.ParticipantId,
          ParticipantResultId: response.ParticipantResultId,
          FirstName: response.FirstName || '',
          MiddleInitial: response.MiddleInitial || '',
          LastName: response.LastName || '',
          EmailId: response.EmailId || '',
          Phone: response.Phone || '',
          Dob: DateHelper.toDateOnlyDisplay(response.Dob),
          Gender: response.Gender === "M" ? "Male" : response.Gender === "F" ? "Female" : (response.Gender || ''),
          Height: response.Height,
          Weight: response.Weight !== undefined && response.Weight !== null ? Number(response.Weight) : null,
          Bmi: response.Bmi !== undefined && response.Bmi !== null ? Number(response.Bmi) : null,
          WhenToCall: response.WhenToCall || '',
          Lastupdated: response.Lastupdated,
          StudyId: response.StudyId,
          StudyName: response.StudyName || '',
          ApplicantStatusId: response.ApplicantStatusId,
          DynamicOptions: response.DynamicOptions,
          AdminId: response.AdminId,
          MailingStreetAddress: response.MailingStreetAddress || '',
          AptSuiteUnit: response.AptSuiteUnit || '',
          City: response.City || '',
          State: response.State || '',
          ZipCode: response.ZipCode || '',
          Country: (response.Country || '').trim() || 'USA',
          RaceId: response.RaceId ? Number(response.RaceId) : null,
          IcfVersionDate: response.IcfVersionDate ? DateHelper.formatDateToDDMMMYYYY(new Date(response.IcfVersionDate)) : '',
          IcfVersionNumber: response.IcfVersionNumber || '',
          ScreeningNumber: response.ScreeningNumber || '',
          ScreenDate: response.ScreenDate ? DateHelper.formatDateToDDMMMYYYY(new Date(response.ScreenDate)) : '',
          EnrollmentNumber: response.EnrollmentNumber || '',
          EnrollmentDate: response.EnrollmentDate ? DateHelper.formatDateToDDMMMYYYY(new Date(response.EnrollmentDate)) : '',
          StatusReason: response.StatusReason || '',
          StatusReasonId: response.StatusReasonId != null ? Number(response.StatusReasonId) : null,
          PreferredContactTime: response.PreferredContactTime || '',
          StudyNote: response.StudyNote || '',
          CompletedStudyDate: response.CompletedStudyDate ? DateHelper.formatDateToDDMMMYYYY(new Date(response.CompletedStudyDate)) : '',
          CancelledDate: response.CancelledDate ? DateHelper.formatDateToDDMMMYYYY(new Date(response.CancelledDate)) : '',
          EarlyTerminationDate: response.EarlyTerminationDate ? DateHelper.formatDateToDDMMMYYYY(new Date(response.EarlyTerminationDate)) : '',
          LosttoFollowUpDate: response.LosttoFollowUpDate ? DateHelper.formatDateToDDMMMYYYY(new Date(response.LosttoFollowUpDate)) : '',
          ScheduledDate: response.ScheduledDate ? DateHelper.formatDateToDDMMMYYYY(new Date(response.ScheduledDate)) : '',
          ScreenedFailedDate: response.ScreenedFailedDate ? DateHelper.formatDateToDDMMMYYYY(new Date(response.ScreenedFailedDate)) : '',
          User: this.currentUserId,
          CurrentDate: this.currentDate,
          GroupMemberId: response.GroupMemberId != null ? Number(response.GroupMemberId) : null,
          IsgroupMember: response.IsgroupMember
        };
        this.heightForDisplay = response.Height !== undefined && response.Height !== null ? Number(ConversionHelper.feetToInches(response.Height)) : null;
        this.dobModel = response.Dob ? new Date(response.Dob) : null;
        this.icfVersionDateModel = response.IcfVersionDate ? new Date(response.IcfVersionDate) : null;
        this.screeningDateModel = response.ScreenDate ? (this.isEditable ? new Date(response.ScreenDate) : null) : null;
        this.enrollmentDateModel = response.EnrollmentDate ? new Date(response.EnrollmentDate) : null;

        if (this.participantDetails.Lastupdated) {
          this.lastUpdated = new Date(this.participantDetails.Lastupdated);
          this.dateModel = this.lastUpdated;
        }

        if (this.participantDetails.DynamicOptions) {
          try {
            this.itemListResponse = Array.isArray(JSON.parse(this.participantDetails.DynamicOptions))
              ? JSON.parse(this.participantDetails.DynamicOptions)
              : [];
          } catch (e) {
            this.itemListResponse = [];
          }
        } else {
          this.itemListResponse = [];
        }

        this.participantDetailsExport = this.participantDetails;

        if (this.participantDetails.ApplicantStatusId) {
          this.updateUIForStatus(Number(this.participantDetails.ApplicantStatusId));
          this.updateDateFieldVisibility(Number(this.participantDetails.ApplicantStatusId));
        }

        if (this.statusReasonList.length > 0) {
          this.filterStatusReasonsByStatus();
        }

        if (this.participantDetails.ApplicantStatusId) {
          this.filteredStatusOptions = [
            ...this.getFilteredStatusOptions(Number(this.participantDetails.ApplicantStatusId))
          ];
        } else {
          this.filteredStatusOptions = [];
        }

        this.cdr.markForCheck();
      });
    });

    this.admin.getParticipantAttempts(this.pid, this.sid)
      .subscribe(r => {
        Promise.resolve().then(() => {
          this.participantAnswers = Array.isArray(r) ? r : [];
          this.cdr.markForCheck();
        });
      }, () => {
        this.router.navigate(['adminhome/notfound']);
      });
  }

  onGroupMemberIdInput(event: any) {
    const val = event.target.value.replace(/^0+/, '');
    this.participantDetails.GroupMemberId = val ? Number(val) : null;
  }

  middleInitialOnly(event: KeyboardEvent) {
    let char = event.key;
    if (!/^[a-zA-Z-]$/.test(char)) {
      event.preventDefault();
      this.middleInitialInvalid = true;
    } else {
      this.middleInitialInvalid = false;
    }
  }

  updateUIForStatus(statusId: number) {
    this.showStatusReason = this.statusReasonStatuses.includes(statusId);
    this.showNewTextField = this.newTextFieldStatuses.includes(statusId);
    this.showNewTextField = this.showReasonTextField();
    this.updateSpecialFieldsVisibility();
    this.updateDateFieldVisibility(statusId);
  }

  filterStatusReasonsByStatus() {
    if (this.participantDetails && this.participantDetails.ApplicantStatusId && this.statusReasonList.length > 0) {
      let currentStatusId = Number(this.participantDetails.ApplicantStatusId);
      this.filteredStatusReasonList = [
        ...this.statusReasonList.filter(reason => reason.ApplicantStatusId === currentStatusId)
      ];
    } else {
      this.filteredStatusReasonList = [];
    }
  }

  addCommunicationNote() {
    const noteText = this.communicationNote?.Note ?? '';
    const trimmedNote = noteText.trim();

    if (this.communicationNote && trimmedNote.length >= 10 && noteText.length <= 500) {
      let note: CommunicationNote = {
        ParticipantId: this.participantDetails.ParticipantId,
        CreatedBy: this.participantDetails.User,
        CreatedOn: new Date(),
        Note: noteText
      };
      this.participantService.SaveApplicantCommunicationNote(note).subscribe(() => {
        this.GetApplicantCommunicationNote();
        setTimeout(() => {
          this.communicationNote.Note = '';
        }, 0);
      });
    }
  }

  GetApplicantCommunicationNote() {
    this.participantService.getApplicantCommunicationNote(this.pid).subscribe((data) => {
      const notes = Array.isArray(data) ? data : [];
      this.communicationNotes = notes;
      this.communicationNotes$.next(notes);
      this.cdr.detectChanges();
    });
  }

  getStudyNote() {
    this.participantService.getApplicantStudyNote(this.pid, this.sid).subscribe((data) => {
      const notes = Array.isArray(data) ? data : [];
      this.studyNoteDetails = notes;
      this.studyNoteDetails$.next(notes);
      this.cdr.detectChanges();
    });
  }

  addStudyNote() {
    const noteText = this.studyNote?.Note ?? '';
    const trimmedNote = noteText.trim();

    if (this.studyNote && trimmedNote.length >= 10 && noteText.length <= 500) {
      let note: StudyNote = {
        ParticipantId: this.participantDetails.ParticipantId,
        StudyId: this.participantDetails.StudyId,
        CreatedBy: this.participantDetails.User,
        CreatedOn: new Date(),
        Note: noteText
      };
      this.participantService.SaveApplicantStudyNote(note).subscribe(() => {
        this.getStudyNote();
        setTimeout(() => {
          this.studyNote.Note = '';
        }, 0);
      });
    }
  }

  onStatusChange($event: any) {
    let selectedStatusId = +($event.target ? $event.target.value : $event);
    if (!this.participantDetails) return;

    this.admin.getParticipantDetails(this.pid, this.sid).subscribe(response => {
      let dbScreenDate = response.ScreenDate ? DateHelper.formatDateToDDMMMYYYY(new Date(response.ScreenDate)) : null;
      let dbEnrollmentDate = response.EnrollmentDate ? DateHelper.formatDateToDDMMMYYYY(new Date(response.EnrollmentDate)) : null;

      this.participantDetails.ApplicantStatusId = selectedStatusId;
      this.participantDetails.StatusReason = '';

      if (dbScreenDate) this.participantDetails.ScreenDate = dbScreenDate;
      if (dbEnrollmentDate) this.participantDetails.EnrollmentDate = dbEnrollmentDate;

      this.filteredStatusReasonList = [
        ...this.statusReasonList.filter(reason => reason.ApplicantStatusId === selectedStatusId)
      ];

      this.updateUIForStatus(selectedStatusId);
      this.updateDateFieldVisibility(selectedStatusId);
      this.showNewTextField = this.showReasonTextField();
      this.updateSpecialFieldsVisibility();
      this.clearIrrelevantDates(selectedStatusId, dbScreenDate, dbEnrollmentDate);
      this.autoSetDateForStatus(selectedStatusId);

      setTimeout(() => {
        this.cdr.detectChanges();
      }, 0);
    });
  }

  autoSetDateForStatus(statusId: number) {
    const now = new Date();
    const formattedDate = DateHelper.formatDateToDDMMMYYYY(now);

    switch (statusId) {
      case ApplicantStatus.CompletedStudy:
        if (!this.participantDetails.CompletedStudyDate) {
          this.participantDetails.CompletedStudyDate = formattedDate;
        }
        break;
      case ApplicantStatus.Cancelled:
        if (!this.participantDetails.CancelledDate) {
          this.participantDetails.CancelledDate = formattedDate;
        }
        break;
      case ApplicantStatus.Scheduled:
        if (!this.participantDetails.ScheduledDate) {
          this.participantDetails.ScheduledDate = formattedDate;
        }
        break;
      case ApplicantStatus.ScreenFailed:
        if (!this.participantDetails.ScreenedFailedDate) {
          this.participantDetails.ScreenedFailedDate = formattedDate;
        }
        break;
      case ApplicantStatus.EarlyTermination:
        if (!this.participantDetails.EarlyTerminationDate) {
          this.participantDetails.EarlyTerminationDate = formattedDate;
        }
        break;
      case ApplicantStatus.LosttoFollowUp:
        if (!this.participantDetails.LosttoFollowUpDate) {
          this.participantDetails.LosttoFollowUpDate = formattedDate;
        }
        break;
      case ApplicantStatus.Screened:
        if (!this.participantDetails.ScreenDate) {
          this.participantDetails.ScreenDate = formattedDate;
        }
        break;
      case ApplicantStatus.Enrolled:
        if (!this.participantDetails.EnrollmentDate) {
          this.participantDetails.EnrollmentDate = formattedDate;
        }
        break;
    }
  }

  onStatusReasonChange(event: any) {
    let selectedReasonId = +event.target.value;
    this.participantDetails.StatusReasonId = selectedReasonId;
    this.showNewTextField = this.showReasonTextField();
    if (!this.showNewTextField) {
      this.participantDetails.StatusReason = "";
    }
    this.cdr.detectChanges();
  }

  private showReasonTextField(): boolean {
    const selectedReasonId = Number(this.participantDetails?.StatusReasonId);
    return this.showStatusReason && this.newTextFieldReasonIds.includes(selectedReasonId) ||
      this.newTextFieldStatuses.includes(Number(this.participantDetails?.ApplicantStatusId));
  }

  updateParticipantDetails(): participantDetails {
    this.validationErrorMessage = false;
    this.showValidationMessage = false;
    
    let isValidSelections = this.validateSectionFields();
    this.validationErrorMessage = !isValidSelections;
    this.showValidationMessage = !isValidSelections;
    
    if (!isValidSelections) {
      return;
    } 

    this.participantDetails.DynamicOptions = JSON.stringify(this.itemListResponse);
    this.participantDetails.CreatedBy = this.participantDetails.User;
    this.participantDetails.CreatedOn = this.participantDetails.CurrentDate;
    this.participantDetails.ModifiedBy = this.participantDetails.User;
    this.participantDetails.ModifiedOn = this.participantDetails.CurrentDate;
    this.participantDetails.IsgroupMember = this.updateGroupMembership;
    this.participantDetails.Height = ConversionHelper.inchesToFeet(this.heightForDisplay);
    this.participantDetails.Dob = DateHelper.toDateOnlyDisplay(this.participantDetails.Dob);
    
    return { ...this.participantDetails };
  }

  private hasValue(v: any): boolean {
    return v !== null && v !== undefined && String(v).trim() !== '' && v !== '';
  }

  private shouldValidateParticipantIdOnSaveByValues(): boolean {
    const p = this.participantDetails; 
        return (
          (this.hasValue(p?.IcfVersionNumber) &&
          this.hasValue(p?.IcfVersionDate) &&
          this.hasValue(p?.ScreeningNumber) &&
          this.hasValue(p?.ScreenDate)) ||
          this.hasValue(p?.EnrollmentDate)
        );
      }
  private isParticipantIdBlank(): boolean {
    const id = this.participantDetails?.GroupMemberId; // use your actual ParticipantId field
    return !this.hasValue(id) || Number(id) <= 0;
  }
  saveParticipantDetails() {   
    if (this.shouldValidateParticipantIdOnSaveByValues() && this.isParticipantIdBlank()) {
      this.showValidationMessage = true;
      return;
    }
    let participantdetails = this.updateParticipantDetails();
    if (participantdetails === undefined)
      return;
    if (!this.isParticipantIdBlank()) {
      this.ValidateParticipantWithGroupMember(participantdetails).subscribe(isValid => {
        if (isValid) {
          this.admin.postUpdateParticipantDetails(participantdetails).subscribe(() => {
            this.participantDetailsExport = this.participantDetails;
            alert('Participant details updated successfully.');
            this.GetAuditParticipantsBySP();
            if (this.participantDetails.ApplicantStatusId) {
              this.filteredStatusOptions = [
                ...this.getFilteredStatusOptions(Number(this.participantDetails.ApplicantStatusId))
              ];
            } else {
              this.filteredStatusOptions = [];
            }
          }, error => {
            console.error('Error updating participant details:', error);
            alert('Failed to update participant details. Please try again.');
            this.GetAuditParticipantsBySP();
          });
        }
      });
    } else {
      this.admin.postUpdateParticipantDetails(participantdetails).subscribe(() => {
        this.participantDetailsExport = this.participantDetails;
        alert('Participant details updated successfully.');
        this.GetAuditParticipantsBySP();
        if (this.participantDetails.ApplicantStatusId) {
          this.filteredStatusOptions = [
            ...this.getFilteredStatusOptions(Number(this.participantDetails.ApplicantStatusId))
          ];
        } else {
          this.filteredStatusOptions = [];
        }
      }, error => {
        console.error('Error updating participant details:', error);
        alert('Failed to update participant details. Please try again.');
        this.GetAuditParticipantsBySP();
      });
    }
  }  

  syncParticipantWithGroupMember() {
    if (this.shouldValidateParticipantIdOnSaveByValues() && this.isParticipantIdBlank()) {
      this.showValidationMessage = true;
      return;
    }
    let participantdetails = this.updateParticipantDetails();
     this.ValidateParticipantWithGroupMember(participantdetails).subscribe(isValid => {
      if(isValid)
      {
          this.admin.syncParticipantWithGroupMember(participantdetails).subscribe((isSynced) => {
          if (isSynced) {
            alert('Participant successfully synced with the group member');
          } else {
            alert('Failed to sync the participant with the group member.');
          }
        }); 
      }
     }); 
  }

 ValidateParticipantWithGroupMember(participantDetails: participantDetails) {
  return this.admin.ValidateParticipantWithGroupMember(participantDetails).pipe(
    map((groupMembers: boolean) => {
      if (!groupMembers) {
        alert('The participant ID does not belong to the corresponding group member.');
      }
      return groupMembers;
    })
  );
}

  exportAsXLSX(): void {
    this.exportDetails = [];
    const datePipe = new DatePipe('en-US');

    this.exportDetails.push({
      Applicant_Name: (this.participantDetailsExport?.LastName || '') + ' ' + (this.participantDetailsExport?.FirstName || ''),
      Email_Address: this.participantDetailsExport?.EmailId || '',
      Contact_number: this.participantDetailsExport?.Phone || '',
      Preferred_Contact_time: this.participantDetailsExport?.WhenToCall || '',
      Study_Number: this.participantDetailsExport?.StudyName || '',
      Birthdate: this.participantDetailsExport?.Dob || '',
      Gender: this.participantDetailsExport?.Gender || '',
      Weight: this.participantDetailsExport?.Weight.toString() || '',
      BMI: this.participantDetailsExport?.Bmi.toString() || '',
      Last_updated: datePipe.transform(this.participantDetailsExport?.Lastupdated, 'dd/MM/yyyy HH:mm')
    });

    this.exportDetails.push({ Applicant_Name: "" });
    this.exportDetails.push({ Applicant_Name: "" });
    this.exportDetails.push({
      Applicant_Name: "Question",
      Email_Address: "Attempt 1",
      Contact_number: "Attempt 2",
      Preferred_Contact_time: "Attempt 3"
    });

    for (let i = 0; i < this.participantAnswers.length; i++) {
      this.exportDetails.push({
        Applicant_Name: this.participantAnswers[i]?.questiontext || '',
        Email_Address: this.participantAnswers[i]?.answer1 || '',
        Contact_number: this.participantAnswers[i]?.answer2 || '',
        Preferred_Contact_time: this.participantAnswers[i]?.answer3 || ''
      });
    }
    let fileName = this.exportDetails[0].Applicant_Name;
    this.exportExcel.exportAsExcelFile(this.exportDetails, fileName);
  }

  public onFilterChange(event, filter) {
    if (typeof event.defaultPrevented !== "undefined") {
      event.preventDefault();
    }
    if (filter === "level") {
      this.dateTimeRangePickerSettings = this.getDateTimeRangeSettings();
      this.dateTimeRangePickerSettings.type = event.value;
    }
  }

  public getDateTimeRangeSettings(): Settings {
    return {
      singleDatePicker: true,
      displayEndDate: true,
      retailCalendar: false,
      timezoneSupport: false,
      timePicker: false,
      type: this.selectedOption,
      viewDateFormat: "MM-DD-YYYY",
      placeholder: "Date Time Range",
      inputDateFormat: "MM-DD-YYYY"
    };
  }

  formatPhoneNumber(event: Event): void {
    let input = event.target as HTMLInputElement;
    let numbers = input.value.replace(/\D/g, '');
    if (numbers.length > 10) {
      numbers = numbers.substring(0, 10);
    }
    let formatted = '';
    if (numbers.length > 0) {
      formatted = numbers.substring(0, 3);
      if (numbers.length > 3) {
        formatted += '-' + numbers.substring(3, 6);
      }
      if (numbers.length > 6) {
        formatted += '-' + numbers.substring(6, 10);
      }
    }
    if (this.participantDetails) {
      this.participantDetails.Phone = formatted;
    }
    input.value = formatted;
  }

  onlyNumberKey(event: KeyboardEvent): boolean {
    let charCode = event.which ? event.which : event.keyCode;
    return charCode >= 48 && charCode <= 57;
  }

  validateDate() {
    if (!this.participantDetails?.Dob) {
      this.dobChecked = false;
      return;
    }
    let dobDate = new Date(this.participantDetails.Dob);
    if (dobDate < this.minDate || dobDate > this.maxDate) {
      this.dobChecked = false;
    } else {
      this.dobChecked = true;
    }
  }

  private validateSectionFields(): boolean {
    let d = this.participantDetails || {} as participantDetails;

    if (
      !d.FirstName ||
      !d.MiddleInitial ||
      !d.LastName ||
      !d.ApplicantStatusId ||
      !d.Dob ||
      !d.Gender ||
      !d.Bmi ||
      !d.Height ||
      !d.Weight ||
      !d.RaceId ||
      !d.Phone ||
      !d.EmailId ||
      !d.PreferredContactTime ||
      !d.MailingStreetAddress ||
      !d.City ||
      !d.State ||
      !d.ZipCode ||
      !d.Country ||
      !this.heightForDisplay 
    ) {
      return false;
    }

    let emailPattern = /^[a-zA-Z0-9.\-_]+@[a-zA-Z.\-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(d.EmailId)) {
      return false;
    }

    if (!this.dobChecked) {
      return false;
    }

    if (!this.validateEnrollmentDateOrder()) {
      return false;
    }

    const applicantStatusId = Number(d.ApplicantStatusId);
    const statusReasonId = Number(d.StatusReasonId);

    switch (applicantStatusId) {
      case ApplicantStatus.Screened:
        if (!d.ScreeningNumber || !d.ScreenDate) {
          return false;
        }
        if (!this.isValidDateString(d.ScreenDate)) {
          return false;
        }
        if (!d.IcfVersionNumber || !d.IcfVersionDate) {
          return false;
        }
        if (!this.isValidDateString(d.IcfVersionDate)) {
          return false;
        }
        if (d.IcfVersionDate && d.ScreenDate) {
          const icfDate = new Date(d.IcfVersionDate);
          const screeningDate = new Date(d.ScreenDate);
          if (icfDate > screeningDate) {
            return false;
          }
        }
        break;
      case ApplicantStatus.Enrolled:
        if (!d.EnrollmentDate) {
          return false;
        }
        if (!this.isValidDateString(d.EnrollmentDate)) {
          return false;
        }
        break;
      case ApplicantStatus.CompletedStudy:
        if (!d.CompletedStudyDate) {
          return false;
        }
        break;
      case ApplicantStatus.Scheduled:
        if (!d.ScheduledDate) {
          return false;
        }
        break;
      case ApplicantStatus.ScreenFailed:
        if (!d.ScreenedFailedDate || !d.StatusReasonId) {
          return false;
        }
        break;
      case ApplicantStatus.EarlyTermination:
        if (!d.EarlyTerminationDate || !d.StatusReasonId) {
          return false;
        }
        if (statusReasonId === StatusReason.EarlyTerminatedOther && !d.StatusReason) {
          return false;
        }
        break;
      case ApplicantStatus.Cancelled:
        if (!d.CancelledDate || !d.StatusReason) {
          return false;
        }
        break;
      case ApplicantStatus.LosttoFollowUp:
        if (!d.LosttoFollowUpDate) {
          return false;
        }
        break;
      case ApplicantStatus.Other:
        if (!d.StatusReason) {
          return false;
        }
        break;
      default:
        break;
    }

    if (applicantStatusId === ApplicantStatus.Other && statusReasonId === StatusReason.Other && !d.StatusReason) {
      return false;
    }

    if (this.isStatusReasonInvalid) {
      return false;
    }

    return true;
  } 

  updateScreeningFieldsVisibility() {
    let statusId = Number(this.participantDetails?.ApplicantStatusId);
    this.showScreeningFields = statusId === 9;
    if (this.showScreeningFields && !this.participantDetails.ScreenDate) {
      let now = new Date();
      this.participantDetails.ScreenDate = DateHelper.formatDateToDDMMMYYYY(now);
    }
  }

  onScreeningDateChange(date: Date | null) {
    this.participantDetails.ScreenDate = date ? DateHelper.formatDateToDDMMMYYYY(date) : null;
    this.validateEnrollmentDateOrder();
  }

  onEnrollmentDateChange(date: Date | null) {
    this.participantDetails.EnrollmentDate = date ? DateHelper.formatDateToDDMMMYYYY(date) : null;
    this.validateEnrollmentDateOrder();
  }

  private validateEnrollmentDateOrder(): boolean {
    this.enrollmentDateError = '';

    const screeningDate = DateHelper.parseDateValue(this.participantDetails?.ScreenDate);
    const enrollmentDate = DateHelper.parseDateValue(this.participantDetails?.EnrollmentDate);

    if (!screeningDate && enrollmentDate) {
      this.enrollmentDateError = 'Screening Date is required when Enrollment Date is provided.';
      return false;
    }

    if (!screeningDate || !enrollmentDate) {
      return true;
    }

    const dateCompareResult = DateHelper.dateCompare(enrollmentDate, screeningDate);
    if (dateCompareResult === null) {
      return true;
    }

    if (dateCompareResult < 0) {
      this.enrollmentDateError = 'Enrollment Date cannot be earlier than Screening Date.';
      return false;
    }

    return true;
  }



  onCompletedStudyDateChange(date: Date | null) {
    this.participantDetails.CompletedStudyDate = date ? DateHelper.formatDateToDDMMMYYYY(date) : null;
  }

  onCancelledDateChange(date: Date | null) {
    this.participantDetails.CancelledDate = date ? DateHelper.formatDateToDDMMMYYYY(date) : null;
  }

  onScheduledDateChange(date: Date | null) {
    this.participantDetails.ScheduledDate = date ? DateHelper.formatDateToDDMMMYYYY(date) : null;
  }

  onScreenFailedDateChange(date: Date | null) {
    this.participantDetails.ScreenedFailedDate = date ? DateHelper.formatDateToDDMMMYYYY(date) : null;
  }

  onEarlyTerminationDateChange(date: Date | null) {
    this.participantDetails.EarlyTerminationDate = date ? DateHelper.formatDateToDDMMMYYYY(date) : null;
  }

  onLostToFollowUpDateChange(date: Date | null) {
    this.participantDetails.LosttoFollowUpDate = date ? DateHelper.formatDateToDDMMMYYYY(date) : null;
  }

  updateSpecialFieldsVisibility() {
    let statusId = Number(this.participantDetails?.ApplicantStatusId);
    this.showScreeningFields = statusId === ApplicantStatus.Screened;
    this.showEnrollmentFields = statusId === ApplicantStatus.Enrolled;

    if (this.showScreeningFields && !this.participantDetails.ScreenDate) {
      let now = new Date();
      this.participantDetails.ScreenDate = DateHelper.formatDateToDDMMMYYYY(now);
    }
    if (this.showEnrollmentFields && !this.participantDetails.EnrollmentDate) {
      let now = new Date();
      this.participantDetails.EnrollmentDate = DateHelper.formatDateToDDMMMYYYY(now);
    }
  }

  onICFDateChange(date: Date | null) {
    if (date) {
      this.participantDetails.IcfVersionDate = DateHelper.formatDateToDDMMMYYYY(date);
    } else {
      this.participantDetails.IcfVersionDate = null;
    }
    this.icfDateError = '';
    const icfDateStr = this.participantDetails.IcfVersionDate;
    const screeningDateStr = this.participantDetails.ScreenDate;
    if (icfDateStr && screeningDateStr) {
      const icfDate = new Date(icfDateStr);
      const screeningDate = new Date(screeningDateStr);
      if (icfDate > screeningDate) {
        this.icfDateError = 'ICF Date cannot be after Screening Date.';
      }
    }
  }

  alphanumericOnly(event: KeyboardEvent) {
    let char = event.key;
    if (!/^[a-zA-Z0-9]$/.test(char)) {
      event.preventDefault();
    }
  }

  updateDateFieldVisibility(statusId: number) {
    this.showCompletedStudyDate = statusId === ApplicantStatus.CompletedStudy;
    this.showCancelledDate = statusId === ApplicantStatus.Cancelled;
    this.showScheduledDate = statusId === ApplicantStatus.Scheduled;
    this.showScreenFailedDate = statusId === ApplicantStatus.ScreenFailed;
    this.showEarlyTerminationDate = statusId === ApplicantStatus.EarlyTermination;
    this.showLostToFollowUpDate = statusId === ApplicantStatus.LosttoFollowUp;
  }


  private getCurrentApplicantStatusId(): number {
    const statusId = Number(this.participantDetails?.ApplicantStatusId);
    return Number.isFinite(statusId) ? statusId : 0;
  }

  isEditable(fieldGroup: 'screening' | 'enrollment'): boolean {
    const statusId = this.getCurrentApplicantStatusId();
    const editableStatuses = fieldGroup === 'screening'
      ? this.screeningEditableStatuses
      : this.enrollmentEditableStatuses;

    return editableStatuses.includes(statusId);
  }


  getFilteredStatusOptions(selectedStatusId: number): ApplicantStatusModel[] {
    let allowedIds = this.statusOptionMap[selectedStatusId];
    let idsToShow: number[] = [];

    if (allowedIds && allowedIds.length > 0) {
      idsToShow = Array.from(new Set([selectedStatusId, ...allowedIds]));
    } else {
      idsToShow = [selectedStatusId];
    }
    return this.applicantStatusList.filter(option => idsToShow.includes(option.ApplicantStatusId));
  }

  private isValidDateString(dateStr: string): boolean {
    if (!dateStr) return false;
    const date = new Date(dateStr);
    return !Number.isNaN(date.getTime());
  }

  getDynamicOptionLabel(option: string): string {
    let inchOptions = [
      'Upper Arm Circumference',
      'Wrist Circumference',
      'Waist Circumference'
    ];
    return inchOptions.includes(option) ? `${option} (inches)` : option;
  }
  alphaOnly(event: KeyboardEvent): void {
    let char = event.key;
    const input = event.target as HTMLInputElement;
    if (char === ' ' && (!input?.value || input.value.trim().length === 0)) {
      event.preventDefault();
      return;
    }
    if (!/^[a-zA-Z ]$/.test(char)) {
      event.preventDefault();
    }
  }

  calculateBMI() {

    if (!this.participantDetails.Weight || !this.heightForDisplay) return null;
    const feet = Math.floor(this.heightForDisplay);
    const inches = Math.round((this.heightForDisplay - feet) * 10); // e.g., 5.8 => 5 feet, 8 inches
    const totalInches = feet * 12 + inches;
    if (!totalInches) return null;
    let bmi = (this.participantDetails.Weight / (totalInches * totalInches)) * 703;
    this.participantDetails.Bmi = +bmi.toFixed(2);
  }
  limitInputLength(event: Event, maxLength: number) {
    let element = event.target as HTMLInputElement;
    if (element.value.length > maxLength) { element.value = element.value.slice(0, maxLength); }
  }
 
  get isVisible() {
    return !this.isCollapsed;
  }

  onDynamicSelectionChange() { }

  /**
  * Handle pagination from dynamic table
  */
  onDynamicPageChange(): void {
    if (this.scrollTop && this.scrollTop.nativeElement) {
      this.scrollTop.nativeElement.focus();
    }
  }

  /**
 * Helper to disable selection based on permissions
 */
  disableRowSelection = (): boolean => {
    return false;
  }


  /**
  * Get status name from ApplicantStatus enum by id
  */
  getApplicantStatusName(statusId: number): string {
    if (statusId === null || statusId === undefined) return '';
    return ApplicantStatus[statusId] || '';
  }
  /**
     * Handle filter change from dynamic table
     * Saves filter state to UserPreferencesStore for persistence during tab switches
     * Filter state is cleared on page refresh (store is in-memory)
     */
  onDynamicFilterChange(filterState: DynamicTableFilter): void {
    // Reset search filter flag if a new filter is applied
    this.isSearchFilterApplied = false;

    let filtered = [...this.auditParticipants];

    // Apply global search if present
    if (filterState.searchTerm && filterState.searchTerm.trim() !== '') {
      const searchTerm = filterState.searchTerm.toLowerCase();
      filtered = filtered.filter(item =>
        this.dynamicColumns.some(col => {
          const val = item[col.field];
          return val !== null && val !== undefined && val.toString().toLowerCase().includes(searchTerm);
        })
      );
      this.isSearchFilterApplied = true;
    }
  }

  get isCommunicationNoteInvalid(): boolean {
    const note = this.communicationNote?.Note ?? '';
    const trimmedNote = note.trim();
    // Invalid if: empty, only whitespace, too short, or too long
    return trimmedNote.length === 0 || trimmedNote.length < 10 || note.length > 500;
  }

  get isVisibleBySp() {
    return !this.isCollapsedbySp;
  }

  get isStudyNoteInvalid(): boolean {
    const note = this.studyNote?.Note ?? '';
    const trimmedNote = note.trim();

    // Invalid if: empty, only whitespace, too short, or too long
    return trimmedNote.length === 0 || trimmedNote.length < 10 || note.length > 500;
  }

  get isStatusReasonInvalid(): boolean {
    if (!this.showNewTextField) {
      return false;
    }

    const reason = this.participantDetails?.StatusReason ?? '';
    const trimmedReason = reason.trim();
    return trimmedReason.length < 10 || reason.length > 500;
  }

  GetAuditParticipantsBySP() {
    this.isAuditLoadingBySp = true;
    this.participantService.GetAuditParticipantsBySP(this.pid).subscribe((data) => {
      Promise.resolve().then(() => {
        this.auditParticipantsBySp = Array.isArray(data) ? data : [];
        this.auditParticipantsBySp.forEach(participant => {
          participant.ModifiedOn = participant.ModifiedOn ? this.stringHelper.changeToCSTFormat(new Date(participant.ModifiedOn)) : participant.ModifiedOn;
          if (participant.ColName === 'Height') {
            participant.NewValue = participant.NewValue !== null ? Number(ConversionHelper.feetToInches(participant.NewValue)).toString() : null;
            participant.PrevValue = participant.PrevValue !== null ? Number(ConversionHelper.feetToInches(participant.PrevValue)).toString() : null;
          }
        });
        this.isAuditLoadingBySp = false;
        this.cdr.markForCheck();
      });
    });
  }


  onDynamicExportAuditBySp(): void {
    let auditParticipantsExportBySp = [];
    if (this.auditParticipantsBySp.length) {
      this.auditParticipantsBySp.forEach(par => {
        let participantDetail: any = {
          'Action Performed': par.Action,
          'Modified On': par.ModifiedOn ? this.stringHelper.changeToCSTFormat(new Date(par.ModifiedOn)) : par.ModifiedOn,
          'Modified By': par.ModifiedBy,
          'Field Name': par.ColName,
          'Previous Value': par.PrevValue,
          'Updated Value': par.NewValue,
        };
        auditParticipantsExportBySp.push(participantDetail);
      });

      setTimeout(() => {
        this.exportExcel.exportAsExcelFile(auditParticipantsExportBySp, 'Audit_Participants');
      }, 1000);
    } else {
      alert('No Audit participants found.');
    }
  }

  private clearIrrelevantDates(statusId: number, dbScreenDate: string | null, dbEnrollmentDate: string | null) {
    if (statusId === ApplicantStatus.Screened) {
      if (!dbEnrollmentDate) {
        this.participantDetails.EnrollmentDate = null;
        this.participantDetails.EnrollmentNumber = null;
      }
    }
    if (statusId === ApplicantStatus.Enrolled) {
      if (!dbScreenDate) {
        this.participantDetails.ScreenDate = null;
      }
    }
    if (statusId !== ApplicantStatus.Screened && !dbScreenDate) {
      this.participantDetails.ScreenDate = null;
    }
  }
}
